import { Navigate } from "react-router-dom";
import { useFakeToken } from "../hooks/useFakeToken";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
  serviceId?: string;
}

export const PrivateRoute = ({
  component: Component,
  ...props
}: PrivateRouteProps) => {
  var token = useFakeToken();
  if (token.isTokenExpired()) return <Navigate to="/login" replace />;
  return <Component {...props} />;
};
